import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { PopoverController, ModalController, AlertController, NavParams } from '@ionic/angular';
import { SharedService } from 'src/app/Services/sheared/sharedService.service';
import { AssureurService } from 'src/app/Services/Assureur/assureur.service';
import { Observable } from 'rxjs';
import { ResponseCotationPage } from '../ResponseCotation/ResponseCotation.page';
import { IonicSelectableComponent } from 'ionic-selectable';
import { CotationService } from 'src/app/Services/Cotation/cotation.service';
import { PaiementService } from 'src/app/Services/Paiement/paiement.service';
import { authenticationService } from 'src/app/Services/Authentication/authentication.service';
import { isUndefined } from 'util';



@Component({
  selector: 'app-paiesimulate',
  templateUrl: './paiesimulate.component.html',
  styleUrls: ['./paiesimulate.component.scss'],
})
export class PaiesimulateComponent implements OnInit {
  myDateDep:any
  countries: any[] = [];
  select_Country: any;
  AirtelAffiche: boolean = false;
  MobicashAffiche: boolean = false;
  private mode_p = "AirtelMoney";
  isEnabled: boolean;
  items: any[]=[];
  CodeAssur: any;
  objAssur:any
  private ref: string;

  constructor(private _countriesService: AssureurService,
    private _paiementservice:PaiementService,
    private nvparms:NavParams,
    private auth:authenticationService,
    private cotationservice:CotationService,
    private alertController:AlertController,private shard:SharedService,
    private modalcontroller:ModalController) {
      
      this._countriesService.getAssureurs();

   }
   async onCloseModal(){
      setTimeout(() => {
        this.modalcontroller.dismiss()
      });

    //this.facto.setData(50,"")
    // setTimeout(() => {
    //   this._router.navigate(['/home/cotation/formulaireauto'])
    // },300);
    
    }
    onAirtelMoney(event) {
      this.mode_p = event.target.value
      this.AirtelAffiche = true
      this.MobicashAffiche = false
     // this.select_Country=""
      this.StateButton()
    }
    onMobicashMoney(event) {
      this.mode_p = event.target.value
      this.MobicashAffiche = true
      this.AirtelAffiche = false
      this.select_Country=""
      this.StateButton()
    }
    
   async Resultat(_objetResult) {
     
     
     let ob =_objetResult
     ob.TypeObjet = _objetResult.type
    const modal = await this.modalcontroller.create({
      component: ResponseCotationPage,
      //cssClass:'garantie-modal',
      componentProps: {
        value: ob,


      }
    });

    await modal.present();
  }
  
  userChange(event: { component: IonicSelectableComponent, value: any }) {
    this.select_Country = ""
    if (event.value) {
      this.mode_p = "Airtel Money"
      this.select_Country = event.value.codeAir
    } else {
      //this.retirer=true
      this.select_Country="";
      this.mode_p = ""
    }
    this.StateButton();
  }

  StateButton() {
    this.isEnabled=false;
 
      if ((this.AirtelAffiche && this.select_Country) || this.MobicashAffiche ) {
        this.isEnabled=true;
        //this.ref= new Date().getFullYear()+this.items[index].$key.substr(-5);
       // this.CodeAssur=this.items[index].CodeAssur
        // if (this.provenance==="New") {
        //  // this.ref= new Date().getFullYear()+this.items[index].$key.substr(-5);
        //  // this.CodeAssur=this.items[index].CodeAssur
        // } else {
        //   this.ref= new Date().getFullYear()+this.items[index].$key.substr(-5);
        // this.CodeAssur=this.items[index].CodeAssur
        // }
        
        
      }      
    
    
    // if (this.AirtelAffiche && this.select_Country) {
    //   this.isEnabled=true;
    // }
  }

  onValider(){   
    let simulMount=isUndefined(this.objAssur)? 1000 :this.objAssur.simulaMount
      let  trans = {
        "reason": "prime payée pour simulation ",
        "operator": this.select_Country,
        "trxid": this.ref,
        "amount": simulMount,//.replace(/ /g, "") * 1,
        "consumerid": "10035a6a-0a70-11ea-8254-42010a8401c0",
        "mobile": 2222//data.mobile.replace(/ /g, "")
      }
      this.onCloseModal()
    this._paiementservice.apiMOBILEmoney(trans)
    .then(
      observable =>{
        observable.subscribe(
          (res) =>{       
              if (res.code===200) { 
                //this.onCloseModal()
                this.cotationservice.addSimulalteMoney(this.auth.profile.uid,{               
                  dateIns:this.shard.getTimeStampFromToday(),
                  h:this.shard.getDateSepar().h,
                  mm:this.shard.getDateSepar().m,
                  montant:simulMount,
                  revenuMontant:0,
                  retraitMontant:0,
                  modPaie:this.mode_p,
                  dateMax:15,
                  heureMax:1440,
                  valid:true,
                 
                 }).then(
                   _ => {
                     this._paiementservice.loading.dismiss()

                      this.Resultat(this.nvparms.get('value'))

                     
                       }
                   
                 ).catch(
                  err =>{
                    console.error();
                    this._paiementservice.loading.dismiss()
                  } 
                 )
                }})})





   
    
  }
  ngOnInit() {
    this.countries = this._countriesService.getCountries();

    //console.log(this.nvparms.get('value'));
    
    this._countriesService.ListAssreurs.subscribe(
      resul => {
        
             this.objAssur=resul//.find(e => e.CodeAssu==this.auth.profile.CodeAssu);
              
              //simulaMount
      }
    )
  }
}
